import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import HomeCaroselParallax from 'components/Parallax/HomeCaroselParallax.jsx';
import { compose } from 'redux';
import { withTheme } from '@material-ui/core/styles';
import HOCLoader from '../../components/HOC/HOCLoader.jsx';
import profilePageStyle from 'assets/jss/material-kit-react/views/profilePage.jsx';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import HomeSearchBar from '../../components/SearchBar/HomeSearchBar.js';
import ProviderListItem from '../../components/Providers/ProviderListItem';
// import SideFeatured from '../../components/Providers/SideFeatured.js';
import RecentlyViewed from '../../components/Providers/RecentlyViewed.js';
import withUser from '../../components/HOC/HOCwithUser.jsx';
import { Card, Button } from '@material-ui/core';
import MenuButton from '../../components/Menu/MenuButton';
import { FilterList } from '@material-ui/icons';
import { PROVIDER_FILTER_MENU_DATA } from '../../utils/config/constants';
import { FormattedMessage, injectIntl } from 'react-intl';
import SideFilters from '../../components/Providers/SideFilters.js';
import { Redirect } from 'react-router-dom';
import AppLinks from '../../components/About/AppLinks';

import list1 from 'assets/images/services/s1.jpg';
import list2 from 'assets/images/services/s4.jpg';
import list3 from 'assets/images/services/tr2.jpg';
import list4 from 'assets/images/services/s6.jpg';
import list5 from 'assets/images/services/s7.jpg';
import list6 from 'assets/images/services/s8.jpg';
import BestRatedList from '../../components/Providers/BestRatedList.jsx';
import ServicePopup from '../../components/Providers/ServicePopup.js';

class ProviderListing extends React.Component {
    constructor(props) {
        super();
        if (props.match.params) {
            this.state = {
                city: props.match.params.city ? props.match.params.city : '',
                service: props.match.params.service
                    ? props.match.params.service
                    : '',
                category: props.match.params.category
                    ? props.match.params.category
                    : 'all',
                providerData: props.location.state
                    ? props.location.state.providerData
                    : [],
                loading: true,
                backRedirect: false,
                redirectToCategory: false,
                action: 0,
                featured: false,
                page: 1,
                previous: false,
                next: false,
                bestRatedProviders: [],
                keyword: props.match.params ? props.match.params.keyword : '',
                loader: true,
                servicePopup: false,
                selectedProvider: ''
            };
        } else {
            this.state = {
                city: '',
                keyword: '',
                service: '',
                category: 'all',
                loading: true,
                backRedirect: false,
                redirectToCategory: false,
                action: 0,
                featured: false,
                page: 1,
                previous: false,
                next: false,
                providerData: [],
                bestRatedProviders: [],
                loader: true,
                servicePopup: false,
                selectedProvider: ''
            };
        }
    }
    clickedProvider = provider => {
        this.setState({ servicePopup: true, selectedProvider: provider });
    };
    closeServicePopup = () => {
        this.setState({ servicePopup: false });
    };
    componentDidMount() {
        this.getData();

        if (!this.props.categories.categoryData[0].heading) {
            this.getCategories();
        }
    }
    getCategories = () => {
        this.props.allCategoryAction();
    };
    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.city != this.props.city ||
            prevProps.serviceName != this.props.serviceName ||
            prevProps.category != this.props.category
        ) {
            this.getData();
        }
    }

    getData = () => {
        this.props.bestRatedProviderAction(this.onRatedDone);
        // this.props.providerMainSearchListAction(
        //     {
        //         serviceName: this.state.keyword,
        //         type: 0,
        //         featured: this.state.featured,
        //         category: this.state.category,
        //         city: this.state.city,
        //         service: this.state.service,
        //         page: this.state.page
        //     },
        //     this.onAllDone
        // );
        this.callSearchAction();
    };
    callSearchAction = action => {
        this.props.providerMainSearchListAction(
            {
                serviceName: this.state.keyword,
                type: action ? action : 0,
                featured: this.state.featured,
                category: this.state.category,
                city: this.state.city,
                service: this.state.service,
                page: this.state.page,
                day: new Date().getDay(),
                offset: new Date().getTimezoneOffset()
            },
            this.onAllDone
        );
    };
    onRatedDone = (success, data) => {
        if (success) {
            this.setState({
                bestRatedProviders: data.data,
                loader: false
            });
        } else {
            this.setState({ loader: false });
        }
    };
    onAllDone = (success, data) => {
        console.log({data});
        if (success) {
            this.setState({
                providerData: data.data,
                loader: false,
                next: data.next,
                previous: data.previous
            });
        } else {
            this.setState({ loader: false });
        }
    };

    //Provider Filter Action
    actionCallbacks(action) {
        this.setState({ action: action }, () => {
            // this.callSearchAction();
            this.props.providerMainSearchListAction(
                {
                    serviceName: this.state.keyword,
                    type: action ? action : 0,
                    featured: this.state.featured,
                    category: this.state.category,
                    city: this.state.city,
                    service: this.state.service,
                    page: this.state.page,
                    day: new Date().getDay(),
                    offset: new Date().getTimezoneOffset()
                },
                this.onFilterDone
            );
        });
    }

    onFilterDone = (success, data) => {
        if (success) {
            this.setState({
                providerData: data.data,
                loader: false,
                previous: data.previous,
                next: data.next
            });
        } else {
            this.setState({ providerData: data.data, loader: false });
        }
    };
    filterViaCategory = () => {
        this.actionCallbacks(0);
        // this.setState({ redirectToCategory: true });
    };
    filterViaType = () => {
        this.actionCallbacks(0);
    };
    changeCategory = category => {
        this.setState({ category: category });
        // this.filterViaCategory();
        this.actionCallbacks(0);
    };

    onProviderTypeSelected = featured => {
        this.setState({ featured });
        this.actionCallbacks(0);
    };
    handlePrevious = () => {
        this.setState(
            prevState => ({
                page: prevState.page - 1
            }),
            () => {
                this.actionCallbacks(0);
            }
        );
    };

    handleNext = () => {
        this.setState(
            prevState => ({
                page: prevState.page + 1
            }),
            () => {
                this.actionCallbacks(0);
            }
        );
    };

    renderPagination = () => {
        return (
            <div className="row mb-3">
                {this.state.previous && (
                    <div className="text-left col-md-6">
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => this.handlePrevious()}
                        >
                            <FormattedMessage
                                id="previous"
                                defaultMessage="Previous"
                            />
                        </Button>
                    </div>
                )}
                {this.state.next && (
                    <div className="text-right col-md-6">
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => this.handleNext()}
                        >
                            <FormattedMessage id="next" defaultMessage="Next" />
                        </Button>
                    </div>
                )}
            </div>
        );
    };
    render() {
        const { classes, settings } = this.props;
        const { providerData, redirectToCategory, loader } = this.state;
        const { formatMessage } = this.props.intl;
        if (redirectToCategory) {
            return (
                <Redirect
                    to={{
                        pathname: `/provider/category/${this.state.category}`,
                        state: {
                            city: this.state.city,
                            category: this.state.category,
                            providerData: this.state.providerData
                        }
                    }}
                />
            );
        }
        return (
            <React.Fragment>
                {/* <HOCLoader loading={this.state.loader}> */}
                <div className="dir-alp dir-pa-sp-top provider-list-top">
                    {/* <HomeCaroselParallax banners={settings.banners} /> */}

                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="dir-alp-tit">
                                    <h1>Provider Listing</h1>
                                    <ol className="breadcrumb">
                                        <li>
                                            <a
                                                onClick={() =>
                                                    this.props.history.push(`/`)
                                                }
                                            >
                                                Home
                                            </a>{' '}
                                        </li>
                                        <li>
                                            <a href="#">Listing</a>{' '}
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <Card>
                            <div className="row">
                                <div className="col-md-6 text-left">
                                    <Button
                                        className="mr-2 mb-2 mt-2 ml-2"
                                        variant={
                                            this.state.featured == false
                                                ? 'contained'
                                                : 'outlined'
                                        }
                                        color="primary"
                                        onClick={() =>
                                            this.onProviderTypeSelected(false)
                                        }
                                    >
                                        <FormattedMessage
                                            id="allProviders"
                                            defaultMessage="All Providers"
                                        />
                                    </Button>

                                    <Button
                                        className="mb-2 mt-2"
                                        variant={
                                            this.state.featured == true
                                                ? 'contained'
                                                : 'outlined'
                                        }
                                        color="primary"
                                        onClick={() =>
                                            this.onProviderTypeSelected(true)
                                        }
                                    >
                                        <FormattedMessage
                                            id="featured"
                                            defaultMessage="Featured"
                                        />
                                    </Button>
                                </div>
                                <div className="col-md-6 text-right">
                                    <MenuButton
                                        items={PROVIDER_FILTER_MENU_DATA.map(
                                            menuData => {
                                                return {
                                                    action: menuData.key,
                                                    label: formatMessage({
                                                        id: menuData.label
                                                    })
                                                };
                                            }
                                        )}
                                        menuId={'providerFilterMenu'}
                                        menuCallback={action =>
                                            this.actionCallbacks(action)
                                        }
                                        iconType={FilterList}
                                    />
                                </div>
                            </div>
                        </Card>

                        <div className="dir-alp-con row mx-0">
                            <div className="col-md-3 dir-alp-con-left">
                                <div className="dir-alp-con-left-1">
                                    <h3>
                                        <FormattedMessage
                                            id="bestRated"
                                            defaultMessage={`Best Rated Providers`}
                                        />
                                    </h3>
                                </div>
                                <div className="dir-hom-pre dir-alp-left-ner-notb">
                                    <BestRatedList
                                        clickedProvider={provider =>
                                            this.clickedProvider(provider)
                                        }
                                        data={this.state.bestRatedProviders}
                                    />
                                </div>

                                <SideFilters
                                    changeCategory={this.changeCategory}
                                    categories={this.props.categories}
                                    selectedCategory={this.state.category}
                                />
                                {/* {this.props.userData.name !== '' && (
                                    <RecentlyViewed />
                                )} */}
                            </div>
                            <div className="col-md-9 dir-alp-con-right">
                                <ProviderListItem
                                    searchedValue={this.state.searchedValue}
                                    data={providerData}
                                    loader={loader}
                                />
                                {this.renderPagination()}
                            </div>
                        </div>
                    </div>
                </div>
                <AppLinks settings={this.props.settings} />
                {this.state.selectedProvider && (
                    <ServicePopup
                        provider={this.state.selectedProvider}
                        open={this.state.servicePopup}
                        close={this.closeServicePopup}
                    />
                )}
                {/* </HOCLoader> */}
            </React.Fragment>
        );
    }
}

const mapStateToProps = ({ auth, settings, categories }) => {
    return {
        userData: auth.userData,
        settings: settings,
        categories: categories
    };
};

const composedComponent = compose(
    withTheme(),
    withStyles(profilePageStyle),
    connect(mapStateToProps, actions)
);
export default composedComponent(withUser(injectIntl(ProviderListing)));



// WEBPACK FOOTER //
// ./src/views/User/ProviderListing.jsx